import CustomerDetailPage from "../../pages/dashboard/customers/CustomerDetailPage";
import CustomersPage from "../../pages/dashboard/customers/CustomersPage";

export const CustomerRoutes = [
  {
    name: "Khách hàng",
    path: "",
    element: <CustomersPage />,
  },
  {
    name: "Khách hàng",
    path: ":id",
    element: <CustomerDetailPage />,
  },
];
